import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { persistor, store } from "./StateManagement/Store";
import ErrorBoundary from "./Landing/Components/ErrorBoundry/ErrorBoundry";
// import {IntlProvider} from "react-intl";

import { PrimeReactProvider, PrimeReactContext } from "primereact/api";
import { MenuProvider } from "./StateManagement/Contexts/MenuContext";

import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import {
  ShopContext,
  ShopListProvider,
  ShopProvider,
} from "./StateManagement/Contexts/ShopContext";

serviceWorkerRegistration.unregister();
// const locale = 'fa-IR'; // Set to 'fa' for Persian (Farsi)
// const messages = {
//     fa: {
//         calendar: 'تقویم',
//         // Add more translations as needed
//     },
const root = ReactDOM.createRoot(document.getElementById("root"));
// }; // Include translations if needed
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      {/*<IntlProvider locale={locale} messages={messages}>*/}
      <ErrorBoundary>
        <PrimeReactProvider>
          <MenuProvider>
            <ShopListProvider>
              <ShopProvider>
                <App />
              </ShopProvider>
            </ShopListProvider>
          </MenuProvider>
        </PrimeReactProvider>
      </ErrorBoundary>
      {/*</IntlProvider>,*/}
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
